import { execute } from '@/graphql/execute';
import { acceptInvitationMutation } from '@/queries/organization.query';
import { toast } from 'sonner';

export const acceptInvitation = async (token: string) => {
  try {
    const data = await execute(acceptInvitationMutation, { token });
    if (data.acceptInvitation.success) {
      toast.success('Invitation accepted successfully!', {
        description: `You have been added to the organization ${data.acceptInvitation.organization?.name}`,
      });

      return '/';
    }
    throw new Error(data.acceptInvitation.error || 'Failed to accept invitation');
  } catch (error: any) {
    toast.error('Failed to accept invitation', {
      description: error.message || 'An error occurred while accepting the invitation',
    });
    return '/';
  }
};
